import ValidateSingleLoadAdjustment from './ValidateSingleLoadAdjustment';

const ValidateAllLoadAdjustments = (loadAdjustments) => {
  const allAdjustmentsAreValid = loadAdjustments?.every((adjustment) => {
    return ValidateSingleLoadAdjustment(adjustment);
  });
  return allAdjustmentsAreValid;
};

export default ValidateAllLoadAdjustments;
